// extracted by mini-css-extract-plugin
export default {"root":"YyvwEl7cv2","label":"n6QiyirwCd","readonlyText":"rFRuXQTE9P"};